const loadingTypes = {
  idle: 'idle',
  start: 'start',
  success: 'success',
  error: 'error',
  finish: 'finish',
}

export default loadingTypes